const AlertWarning = (props: React.HTMLAttributes<SVGElement>): JSX.Element => (
  <svg
    {...props}
    xmlns="http://www.w3.org/2000/svg"
    width="24"
    height="21"
    viewBox="0 0 24 21"
    fill="none"
  >
    <path d="M12 0L24 20.7846H0L12 0Z" fill="#C67917" />
    <path
      d="M11.3404 15.6128L11.1702 7H12.7191L12.5489 15.6128H11.3404ZM11.9872 19C11.7035 19 11.4652 18.9092 11.2723 18.7277C11.0908 18.5348 11 18.3021 11 18.0298C11 17.7574 11.0908 17.5305 11.2723 17.3489C11.4652 17.156 11.7035 17.0596 11.9872 17.0596C12.2596 17.0596 12.4865 17.156 12.6681 17.3489C12.861 17.5305 12.9574 17.7574 12.9574 18.0298C12.9574 18.3021 12.861 18.5348 12.6681 18.7277C12.4865 18.9092 12.2596 19 11.9872 19Z"
      fill="white"
    />
  </svg>
);
export default AlertWarning;
